import { BaseViewStore } from 'core/stores';
import { action, observable } from 'mobx';
import { FacilityOrderService } from "application/facility-order/services";

class FacilityOrderNewFlowMissingInventoryCountConfirmModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.facilityOrder = componentsProps.modalParams.data.facilityOrder;
        this.getFacilityOrderStatuses = componentsProps.modalParams.data.getFacilityOrderStatuses;
        this.modalParams = componentsProps.modalParams;
        this.facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
    }

	@action.bound
	async processInventory() {
		this.isLoading = true;
		try {
			if (!this.facilityOrder.missingInventoryCount) {
				var response = await this.facilityOrderService.setMissingInventoryCount({ facilityOrderId: this.facilityOrder.id });
				if (response && response.data && response.data.customValues && response.data.customValues.isAutoSupplyEnfitAdapter) {
					this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.AUTO_SUPPLY_ENFIT_ADAPTER');
				}

				if(this.facilityOrder.facilityInventoryCountHeaderId)
					window.location.reload();
				else{
					this.facilityOrder.missingInventoryCount = true;
					await this.getFacilityOrderStatuses();
				}
			}
			this.modalParams.close();
		} catch (err) {
			this.rootStore.notificationStore.error('An error occured while trying to update Missing Inventory Count', err);
		}
		this.isLoading = false;
	}
}

export default FacilityOrderNewFlowMissingInventoryCountConfirmModalStore;